import { withErrorBoundary } from 'app/components/error-boundary';
import { withDashboardLayout } from 'app/hooks/with-dashboard-layout';
import { useUser } from 'app/network/user';
import type { NavigationScreen } from 'app/types/navigation';
import { withOptionalMetrics } from 'app/utils/performance/with-metrics';
import { usePageTitle } from 'app/utils/web-helpers';
import { useEffect } from 'react';

import { DailyContributionsScreen } from './daily-contributions-screen';
import { MonthlyStreakSection } from './monthly-streak-section';

const StreakScreenContent: NavigationScreen<'streak'> = ({ navigation }) => {
  const { data: user } = useUser();
  const setPageTitle = usePageTitle('streak');
  useEffect(() => setPageTitle('headerTitle'), [setPageTitle]);

  // Two different lifecycle screens, gated by `user.hasShared`:
  // - Before the user's first own loan: the Duolingo-style daily contributions screen.
  // - After the first own loan: the monthly neighbourhood streak (objective + calendar + savings).
  if (!user?.hasShared) {
    return <DailyContributionsScreen navigation={navigation} />;
  }
  return <MonthlyStreakSection navigation={navigation} />;
};

export const StreakScreen: NavigationScreen<'streak'> = withOptionalMetrics(
  'StreakScreen',
  withErrorBoundary(withDashboardLayout(StreakScreenContent)),
);

export const StreakScreenStandalone: NavigationScreen<'streak'> = withOptionalMetrics(
  'StreakScreenStandalone',
  withErrorBoundary(StreakScreenContent),
);
